module.exports = __webpack_public_path__ + "img/2.4bfe61f3.jpg";